import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FlaskConical, AlertTriangle } from 'lucide-react';
import { Switch } from '../ui/switch';
import { practiceEndsAt } from '../../lib/practice';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PracticeModePanel = ({ authHeaders }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/practice-mode`, authHeaders).then((r) => setS(r.data)).catch(() => toast.error('Could not load practice mode'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = async (on) => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/practice-mode`, { on }, authHeaders);
      setS(r.data);
      toast.success(on ? `Practice mode on until ${practiceEndsAt(r.data.until)}` : 'Practice mode off');
    } catch { toast.error('Could not change practice mode'); } finally { setBusy(false); }
  };

  if (!s) return null;
  const missing = [!s.stripe_ready && 'Stripe', !s.paypal_ready && 'PayPal'].filter(Boolean);
  return (
    <div className={`rounded-2xl border p-6 transition-colors duration-300 ${s.active ? 'bg-[#C5A059]/10 border-[#C5A059]' : 'bg-white border-[#E6DAC5]'}`} data-testid="practice-mode-panel">
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-1"><FlaskConical size={18} className="text-[#3B164C]" /><h3 className="font-semibold text-[#1E1622]">Practice checkout mode</h3></div>
          <p className="text-sm text-[#1E1622]/60 max-w-xl">
            While on, checkouts made from <strong>this logged-in Admin browser</strong> use test payments (Stripe test card, PayPal sandbox). Customers keep paying normally.
            Real emails and downloads are sent, and practice orders are left out of sales figures. Turns off by itself after {s.hours} hours.
          </p>
          <p className="text-sm mt-3 font-medium text-[#3B164C]" data-testid="practice-mode-status">
            {s.active ? `On until ${practiceEndsAt(s.until)}` : 'Off'}
          </p>
          {missing.length > 0 && (
            <p className="text-xs mt-2 text-amber-700 inline-flex items-center gap-1" data-testid="practice-mode-missing">
              <AlertTriangle size={14} /> {missing.join(' and ')} practice keys aren't set up, so {missing.join(' and ')} checkouts will show an error in practice mode.
            </p>
          )}
        </div>
        <Switch checked={s.active} disabled={busy} onCheckedChange={toggle} data-testid="practice-mode-switch" />
      </div>
    </div>
  );
};
